/*!
 * Copyright (C) 2022-2023, Peppermill Inc.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *//*
 *		2022-08-16
 *			- Create intersection observer fallback script.
 *
 *		2022-08-16
 *			- Refactor IntersectionObserverFallback to use TypeScript.
 *			- Add IntersectionObserverFallbackObject interface to IntersectionObserverFallback.ts.
*/

export interface IntersectionObserverFallbackObject {
    currentScroll: number;
    requestID: number;
    elementToObserve: HTMLElement | null,
    lastScrollCheck: number;
    disconnect: () => void;
    resizeFunction: () => void;
    rootBoundsInfo: {
        top: number;
        bottom: number;
    },
    watchFunction: () => void;
    observe: (elementToObserve: HTMLElement) => void;
}

export function IntersectionObserverFallback(observeCallback: (fallbackObject: IntersectionObserverFallbackObject) => void): IntersectionObserverFallbackObject {
    if ('function' !== typeof observeCallback) {
        observeCallback = function () {
        };
    }

    let fallbackObject: IntersectionObserverFallbackObject = {
        currentScroll: 0,
        requestID: 0,
        elementToObserve: null,
        lastScrollCheck: -1,
        disconnect: function () {
            cancelAnimationFrame(fallbackObject.requestID);

            fallbackObject.elementToObserve = null;
            fallbackObject.lastScrollCheck = -1;
            fallbackObject.requestID = 0;

            window.removeEventListener('resize', fallbackObject.resizeFunction);

        },
        resizeFunction: function () {
            fallbackObject.rootBoundsInfo = {
                top: 0,
                bottom: window.innerHeight
            };
        },
        rootBoundsInfo: {
            top: 0,
            bottom: window.innerHeight
        },
        watchFunction: function () {
            observeCallback(fallbackObject);
            fallbackObject.requestID = requestAnimationFrame(fallbackObject.watchFunction);
        },
        observe: function (elementToObserve: HTMLElement) {

            cancelAnimationFrame(fallbackObject.requestID);
            window.removeEventListener('resize', fallbackObject.resizeFunction);
            window.addEventListener('resize', fallbackObject.resizeFunction, {
                passive: true
            });

            fallbackObject.elementToObserve = elementToObserve;
            fallbackObject.requestID = requestAnimationFrame(fallbackObject.watchFunction);

        }
    };

    document
        .addEventListener('scroll', () => {
            fallbackObject.currentScroll = window.scrollY;
        }, {
            passive: true
        });

    return fallbackObject;
}